var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclusive = function SvgExclusive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2837"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2822",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6069",
    d: "m78.332 77.162-4.024-20.7a37.913 37.913 0 0 0 2.858-24.157 38.326 38.326 0 1 0-19.77 41.8Zm-64.9-30.78A27 27 0 1 1 33.54 66.494a27.048 27.048 0 0 1-20.108-20.112",
    fill: "#2bd675"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6070",
    d: "m40.67 21.641 3.587 11.043a1 1 0 0 0 .951.688h11.608a1 1 0 0 1 .589 1.808l-9.391 6.825a1 1 0 0 0-.362 1.116l3.583 11.042a1 1 0 0 1-1.536 1.116l-9.391-6.825a1.008 1.008 0 0 0-1.174 0l-9.395 6.825a1 1 0 0 1-1.536-1.116l3.587-11.042a1 1 0 0 0-.362-1.116l-9.391-6.827a1 1 0 0 1 .585-1.808h11.611a.991.991 0 0 0 .947-.688l3.584-11.041a1 1 0 0 1 1.9 0",
    fill: "#495867"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6071",
    d: "M72.055 52.733a1.941 1.941 0 0 1 1.919 1.648l4.963 21.3a1.942 1.942 0 0 1-2.236 2.212l-22.97-3.765a1.945 1.945 0 0 1-1.623-1.915Z",
    fill: "#2bd675"
  })))));
};
export default SvgExclusive;